<template>
  <div>
    <AuthPage v-if="!authStatus" @result="() => (authStatus = !authStatus)" />
    <div v-else class="main-pricing p-4 p-lg-5">
      <router-view />
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from "@/components/main/footer.vue";
import AuthPage from "@/components/auth.vue";
export default {
  name: "Home",
  data: () => ({
    authStatus: false,
  }),
  components: {
    Footer,
    AuthPage,
  },
  methods: {},
  async mounted() {},
};
</script>

<style>
@import "@/assets/css/style.min.css?2";
.nav.nav-line {
  overflow-x: auto;
}
.nav.nav-line .nav-link {
  cursor: pointer;
}
.nav-icon.nav-icon-sm .nav-link i {
  font-size: 22px !important;
  cursor: pointer;
  margin-left: 10px;
}
.table_center th,
.table_center td {
  text-align: center !important;
  vertical-align: middle !important;
}

.ta_c {
  text-align: center !important;
  vertical-align: middle !important;
}
.ta_l {
  text-align: left !important;
  vertical-align: middle !important;
}
.ta_r {
  text-align: right !important;
  vertical-align: middle !important;
}

.p-10 {
  padding: 10px !important;
}

.bg-item--common {
  background: linear-gradient(
    0deg,
    rgba(77, 80, 92, 0.2) 0%,
    rgba(177, 181, 206, 0.2) 49.12%,
    rgba(202, 208, 246, 0.2) 97.22%
  );
}
.bg-item--uncommon {
  background: linear-gradient(
    0deg,
    rgba(77, 80, 92, 0.2) 0%,
    rgba(42, 147, 192, 0.2) 50.52%,
    rgba(0, 179, 255, 0.2) 100%
  );
}
.bg-item--rare {
  background: linear-gradient(
    0deg,
    rgba(77, 80, 92, 0.2) 0%,
    rgba(86, 107, 215, 0.2) 49.12%,
    rgba(52, 85, 255, 0.2) 97.22%
  );
}
.bg-item--epic {
  background: linear-gradient(
    0deg,
    rgba(77, 80, 92, 0.2) 0%,
    rgba(105, 64, 186, 0.2) 45.94%,
    rgba(135, 75, 255, 0.2) 100%
  );
}
.bg-item--legendary {
  background: linear-gradient(
    0deg,
    rgba(77, 80, 92, 0.2) 0%,
    rgba(192, 57, 219, 0.2) 52.37%,
    rgba(213, 0, 255, 0.2) 100%
  );
}
.bg-item--arcane {
  background: linear-gradient(
    0deg,
    rgba(77, 80, 92, 0.2) 0%,
    rgba(212, 50, 93, 0.2) 53.65%,
    rgba(255, 0, 66, 0.2) 100%
  );
}
.bg-item--gold {
  background: linear-gradient(
    0deg,
    rgba(77, 80, 92, 0.2) 0%,
    rgba(191, 147, 31, 0.2) 54.17%,
    rgba(255, 185, 0, 0.2) 100%
  );
}
.bg-item--gloves {
  background: linear-gradient(
    0deg,
    rgba(77, 80, 92, 0.2) 0%,
    rgba(212, 50, 93, 0.2) 53.65%,
    rgba(255, 0, 66, 0.2) 100%
  );
}
.bg-item--knife {
  background: linear-gradient(
    0deg,
    rgba(77, 80, 92, 0.2) 0%,
    rgba(212, 50, 93, 0.2) 53.65%,
    rgba(255, 0, 66, 0.2) 100%
  );
}
.bg-item--bonus {
  background-image: linear-gradient(135deg, #006400, #000000) !important;
}
</style>
